import angular from "angular";
import resellersModule from "../resellersModule.js";
import { CurrentUser } from "Roblox";

function assetResalePaneController(resaleService, resellersConstants) {
    "ngInject";
    var ctrl = this;

    ctrl.loadResaleData = function () {
        if (ctrl.loadingResaleData) {
            return;
        }

        ctrl.loadingResaleData = true;
        ctrl.resaleDataLoadFailure = false;

        resaleService.getAssetResaleData(ctrl.assetId).then(function (resaleData) {
            ctrl.resaleData = resaleData;
            ctrl.loadingResaleData = false;
        }).catch(function () {
            ctrl.resaleDataLoadFailure = true;
            ctrl.loadingResaleData = false;
        });
    };

    ctrl.getTabActiveClasses = function (tabName) {
        return {
            active: tabName === ctrl.selectedTab
        };
    };

    ctrl.selectTab = function (tabName) {
        ctrl.selectedTab = tabName;
    };

    const init = function () {
        ctrl.authenticatedUser = CurrentUser.isAuthenticated ? {
            id: Number(CurrentUser.userId)
        } : null;

        var assetDataContainer = angular.element("#item-container");
        ctrl.assetData = {
            id: ctrl.assetId,
            name: assetDataContainer.data("item-name"),
            type: assetDataContainer.data("asset-type"),
            productId: assetDataContainer.data("product-id"),
            membershipRequirement: assetDataContainer.data("bc-requirement")
        };

        ctrl.economyMetadata = {
            purchasingEnabled: assetDataContainer.data("is-purchase-enabled")
        };

        ctrl.resellersTabs = resellersConstants.resellersTabs;
        ctrl.selectTab(resellersConstants.resellersTabs.priceChart);

        ctrl.loadResaleData();
    };

    ctrl.$onInit = init;
}

resellersModule.controller("assetResalePaneController", assetResalePaneController);
export default assetResalePaneController;